/* file description */
import { Steps as StepsPc, Drawer, Tabs } from 'antd';
import { Steps as StepMobile } from 'antd-mobile';
import React, { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import { StepsProps } from './type';
import { DescriptionList } from './components/DescriptionList';
import { ApprovalForm } from './components/ApprovalForm';
import { StepTitle } from './components/StepTitle';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { DrawerLayout } from '@/asset/AssetTask/templates/Cascade/components/DrawerLayout';
import useMetaStore from '@/store/useMetaStore';

export const SPSteps: FC<StepsProps> = ({
  items,
  historyProcessData,
  current,
  activeData,
  reload,
  onSuccess,
  onFail,
  onFold,
  refList,
  ...otherProps
}) => {
  const { isMobile } = useMetaStore();
  const Steps = isMobile ? StepMobile : StepsPc;

  const [visible, setVisible] = useState<boolean>(false);
  const [isFold, setIsFold] = useState<boolean>(false);

  const changeFold = () => {
    setIsFold(!isFold);
    onFold && onFold(!isFold);
  };
  return (
    <div className={styles['sp-steps-wrap-box']}>
      {!isMobile && (
        <div className={styles['sp-steps-wrap-icon']}>
          {isFold ? (
            <LeftOutlined onClick={changeFold} />
          ) : (
            <RightOutlined onClick={changeFold} />
          )}
        </div>
      )}
      <div
        className={styles['sp-steps-wrap']}
        style={isFold ? { display: 'none' } : {}}
      >
        <div className={styles['sp-steps-title']}>
          审批流程
          {historyProcessData && historyProcessData.length > 0 && (
            <span
              className={styles['sp-steps-title-span']}
              onClick={() => setVisible(true)}
            >
              查看记录
            </span>
          )}
        </div>
        <Steps {...otherProps} direction="vertical" current={current}>
          {items.map((item, ind) => {
            return (
              <Steps.Step
                title={
                  <StepTitle
                    label={item?.title?.label || item?.title || ''}
                    approvalType={item?.title?.approvalType}
                  />
                }
                description={<DescriptionList description={item.description} />}
                key={ind}
              />
            );
          })}
        </Steps>
        <DrawerLayout
          // getContainer={false}
          title="审批历史记录"
          placement="right"
          onClose={() => setVisible(false)}
          visible={visible}
          width={300}
          mask={false}
          className={styles['drawer-box']}
        >
          <Tabs defaultActiveKey="0" tabPosition="top">
            {historyProcessData?.map((data: any, index: number) => {
              return (
                <Tabs.TabPane
                  tab={`历史记录${index + 1}`}
                  key={`${index}`}
                  forceRender
                >
                  <Steps {...data} direction="vertical" current={data.current}>
                    {data.processData?.map((item: any, ind: number) => {
                      return (
                        <Steps.Step
                          title={
                            <StepTitle
                              label={item?.title?.label || item?.title || ''}
                              approvalType={item?.title?.approvalType}
                            />
                          }
                          description={
                            <DescriptionList description={item.description} />
                          }
                          key={ind}
                        />
                      );
                    })}
                  </Steps>
                </Tabs.TabPane>
              );
            })}
          </Tabs>
        </DrawerLayout>
        {activeData && <div style={{ height: '236px', width: '200px' }} />}
        {activeData && (
          <ApprovalForm
            {...activeData}
            reload={reload}
            onSuccess={onSuccess}
            onFail={onFail}
            refList={refList}
          />
        )}
      </div>
    </div>
  );
};
export default SPSteps;
